import { defineCopy } from '@/i18n'

export default defineCopy('miraSolutions', {
  id: {
    hero: {
      badge: 'Solusi IT Terdepan',
      title: { pre: 'Pusat Solusi IT untuk ', hl: 'Bisnis Anda', post: '' },
      subtitle: 'Kami menyediakan solusi digital inovatif untuk meningkatkan efisiensi dan kinerja bisnis Anda. Dari pengembangan web hingga integrasi cloud.',
      seeServices: 'Lihat Layanan Kami',
      learnMore: 'Pelajari Lebih Lanjut',
      stats: { clients: 'Klien Puas', projects: 'Proyek Selesai', years: 'Tahun Pengalaman' },
      floatInnovative: { title: 'Inovatif', sub: 'Berpikir Maju, Bertindak Strategis' },
      floatProfessional: { title: 'Professional', sub: 'Standar Tinggi untuk Solusi Masa Depan' },
    },
    about: {
      expLine1: 'Tahun',
      expLine2: 'Pengalaman',
      badge: 'Tentang Kami',
      title: { pre: 'Selamat Datang di ', hl: 'Mira Solutions', post: '' },
      lead: 'Partner terpercaya Anda dalam dunia digital. Kami adalah tim profesional yang berkomitmen untuk menghadirkan solusi teknologi yang inovatif dan efektif.',
      text: 'Visi kami adalah memudahkan bisnis dalam bertransformasi ke era digital. Kami percaya bahwa setiap perusahaan, besar atau kecil, berhak mendapatkan alat dan teknologi yang tepat untuk berkembang dan bersaing di pasar global.',
      innovative: { title: 'Solusi Inovatif', sub: 'Teknologi terkini untuk bisnis Anda' },
      team: { title: 'Tim Berpengalaman', sub: 'Profesional di bidangnya' },
      more: 'Selengkapnya',
    },
    services: {
      badge: 'Layanan Kami',
      title: { pre: 'Berbagai Solusi IT untuk ', hl: 'Transformasi Digital', post: '' },
      sub: 'Kami menawarkan layanan lengkap untuk mendukung pertumbuhan bisnis Anda.',
      items: {
        website: { title: 'Pengembangan Company Website', short: 'Website profesional yang menarik untuk meningkatkan visibilitas dan kredibilitas bisnis Anda.' },
        apps: { title: 'Aplikasi Web & Mobile', short: 'Aplikasi inovatif untuk semua platform, dari konsep hingga peluncuran yang user-friendly.' },
        erp: { title: 'Pengembangan Sistem ERP', short: 'Sistem ERP untuk menyederhanakan proses dan meningkatkan efisiensi operasional bisnis.' },
        crm: { title: 'Pengembangan Sistem CRM', short: 'Kembangkan hubungan pelanggan yang lebih kuat dengan wawasan mendalam.' },
        whatsapp: { title: 'WhatsApp Business Platform', short: 'Notifikasi WhatsApp tepat waktu untuk komunikasi langsung dengan audiens Anda.' },
        cloud: { title: 'Cloud & Domain Provider', short: 'Layanan cloud dan domain yang fleksibel, aman, dan dapat diandalkan.' },
      },
    },
    projects: {
      badge: 'Proyek Kami',
      title: { pre: 'Portfolio ', hl: 'Terbaru', post: '' },
      sub: 'Lihat beberapa proyek yang telah kami kerjakan untuk klien kami.',
      items: {
        school: {
          name: 'Sistem Informasi Sekolah',
          description: 'Aplikasi mobile manajemen sekolah terintegrasi dengan modul keuangan, absensi, penilaian, dan agenda siswa.',
        },
        pension: {
          name: 'Sistem Informasi Dana Pensiun',
          description: 'Platform manajemen investasi dana pensiun dengan fitur pengelolaan investasi, keuangan, dan pelaporan transaksi. Dilengkapi dashboard analitik dan audit trail.',
        },
        banking: {
          name: 'Core Banking System',
          description: 'Sistem perbankan inti dengan dashboard monitoring dana masuk, analitik sumber dana, pengelolaan kas, dan pelaporan keuangan komprehensif.',
        },
      },
    },
    stats: {
      success: 'Proyek Berhasil',
      clients: 'Klien Puas',
      projects: 'Proyek Selesai',
      support: 'Dukungan Teknis',
    },
    why: {
      badge: 'Mengapa Kami?',
      title: { pre: 'Mengapa Memilih ', hl: 'Mira Solutions?', post: '' },
      text: 'Kami memahami bahwa setiap bisnis memiliki tantangan unik. Oleh karena itu, kami menawarkan solusi yang disesuaikan untuk memenuhi kebutuhan spesifik Anda.',
      list: [
        'Solusi yang disesuaikan dengan kebutuhan bisnis Anda',
        'Tim yang berpengalaman dan responsif',
        'Teknologi terbaru dan inovatif',
        'Dukungan pelanggan 24/7',
        'Harga kompetitif dan transparan',
      ],
      cards: [
        { title: 'Konsultasi Gratis', text: 'Diskusikan kebutuhan digital Anda dengan ahli kami tanpa biaya.' },
        { title: 'Pengerjaan Cepat', text: 'Kami berkomitmen menyelesaikan proyek tepat waktu dengan kualitas terbaik.' },
        { title: 'Dukungan Penuh', text: 'Maintenance dan dukungan teknis berkelanjutan setelah proyek selesai.' },
        { title: 'Skalabilitas', text: 'Solusi yang dirancang untuk berkembang seiring pertumbuhan bisnis Anda.' },
      ],
    },
    faq: {
      title: { pre: 'Pertanyaan yang Sering ', hl: 'Diajukan', post: '' },
      text: 'Temukan jawaban untuk pertanyaan umum tentang layanan dan proses kerja kami.',
      items: [
        {
          question: 'Berapa lama waktu pengerjaan proyek website?',
          answer: 'Waktu pengerjaan bervariasi tergantung kompleksitas proyek. Untuk website standar, biasanya membutuhkan 2-4 minggu. Untuk aplikasi yang lebih kompleks, bisa memakan waktu 1-12 bulan. Kami akan memberikan estimasi waktu yang jelas di awal proyek.',
        },
        {
          question: 'Apakah tersedia layanan maintenance setelah proyek selesai?',
          answer: 'Ya, kami menyediakan layanan maintenance dan dukungan teknis berkelanjutan. Kami menawarkan paket maintenance bulanan yang mencakup pembaruan keamanan, perbaikan bug, dan dukungan teknis via WhatsApp dan email.',
        },
        {
          question: 'Teknologi apa yang digunakan untuk pengembangan?',
          answer: 'Kami menggunakan teknologi terkini seperti Vue.js dan Flutter untuk frontend, serta .NET, Laravel, Nest.js untuk backend. Dalam pengelolaan database, kami menggunakan MySQL, PostgreSQL, MS SQL Server, hingga MongoDB dan ClickHouse untuk analitik. Untuk infrastruktur, kami bekerja dengan AWS, Google Cloud, BiznetGIO, dan penyedia layanan cloud terpercaya lainnya.',
        },
        {
          question: 'Bagaimana proses kerja sama dimulai?',
          answer: 'Prosesnya dimulai dengan konsultasi gratis untuk memahami kebutuhan Anda. Setelah itu, kami akan membuat proposal lengkap mencakup scope pekerjaan, timeline, dan biaya. Setelah disetujui, kami langsung memulai tahap pengembangan.',
        },
        {
          question: 'Apakah bisa request custom fitur tambahan?',
          answer: 'Tentu saja! Kami selalu terbuka untuk menyesuaikan solusi sesuai kebutuhan unik bisnis Anda. Tim kami akan mendiskusikan fitur tambahan yang diinginkan dan memberikan estimasi biaya dan waktu tambahan yang diperlukan.',
        },
      ],
    },
    cta: {
      badge: 'Mulai Sekarang',
      title: { pre: 'Mari Wujudkan Visi Digital Anda Bersama ', hl: 'Mira Solutions', post: '' },
      text: 'Hubungi kami hari ini untuk mendiskusikan bagaimana kami dapat membantu bisnis Anda tumbuh dan sukses dalam dunia digital yang terus berkembang.',
      contact: 'Hubungi Kami Sekarang',
    },
  },
  en: {
    hero: {
      badge: 'Leading IT Solutions',
      title: { pre: 'The IT Solutions Hub for ', hl: 'Your Business', post: '' },
      subtitle: 'We provide innovative digital solutions that boost your business efficiency and performance. From web development to cloud integration.',
      seeServices: 'See Our Services',
      learnMore: 'Learn More',
      stats: { clients: 'Happy Clients', projects: 'Projects Completed', years: 'Years of Experience' },
      floatInnovative: { title: 'Innovative', sub: 'Forward-Thinking, Strategic Action' },
      floatProfessional: { title: 'Professional', sub: 'High Standards for Future-Ready Solutions' },
    },
    about: {
      expLine1: 'Years of',
      expLine2: 'Experience',
      badge: 'About Us',
      title: { pre: 'Welcome to ', hl: 'Mira Solutions', post: '' },
      lead: 'Your trusted partner in the digital world. We are a team of professionals committed to delivering innovative, effective technology solutions.',
      text: 'Our vision is to make it easy for businesses to move into the digital era. We believe every company, large or small, deserves the right tools and technology to grow and compete in the global market.',
      innovative: { title: 'Innovative Solutions', sub: 'The latest technology for your business' },
      team: { title: 'Experienced Team', sub: 'Experts in their fields' },
      more: 'Read More',
    },
    services: {
      badge: 'Our Services',
      title: { pre: 'IT Solutions for ', hl: 'Digital Transformation', post: '' },
      sub: 'We offer complete services to support your business growth.',
      items: {
        website: { title: 'Company Website Development', short: "Attractive, professional websites that boost your business's visibility and credibility." },
        apps: { title: 'Web & Mobile Apps', short: 'Innovative apps for every platform, from concept to a user-friendly launch.' },
        erp: { title: 'ERP System Development', short: 'ERP systems that simplify processes and improve operational efficiency.' },
        crm: { title: 'CRM System Development', short: 'Build stronger customer relationships with deep insights.' },
        whatsapp: { title: 'WhatsApp Business Platform', short: 'Timely WhatsApp notifications for direct communication with your audience.' },
        cloud: { title: 'Cloud & Domain Provider', short: 'Flexible, secure, and reliable cloud and domain services.' },
      },
    },
    projects: {
      badge: 'Our Projects',
      title: { pre: 'Latest ', hl: 'Portfolio', post: '' },
      sub: 'Take a look at some of the projects we have built for our clients.',
      items: {
        school: {
          name: 'School Information System',
          description: 'An integrated school management mobile app with finance, attendance, grading, and student schedule modules.',
        },
        pension: {
          name: 'Pension Fund Information System',
          description: 'A pension fund investment management platform covering investments, finance, and transaction reporting. Includes an analytics dashboard and audit trail.',
        },
        banking: {
          name: 'Core Banking System',
          description: 'A core banking system with dashboards for monitoring incoming funds, funding source analytics, cash management, and comprehensive financial reporting.',
        },
      },
    },
    stats: {
      success: 'Successful Projects',
      clients: 'Happy Clients',
      projects: 'Projects Completed',
      support: 'Technical Support',
    },
    why: {
      badge: 'Why Us?',
      title: { pre: 'Why Choose ', hl: 'Mira Solutions?', post: '' },
      text: "We understand that every business faces unique challenges. That's why we offer solutions tailored to your specific needs.",
      list: [
        'Solutions tailored to your business needs',
        'An experienced, responsive team',
        'The latest, innovative technology',
        '24/7 customer support',
        'Competitive, transparent pricing',
      ],
      cards: [
        { title: 'Free Consultation', text: 'Discuss your digital needs with our experts at no cost.' },
        { title: 'Fast Delivery', text: 'We are committed to finishing projects on time and to the highest quality.' },
        { title: 'Full Support', text: 'Ongoing maintenance and technical support after the project is done.' },
        { title: 'Scalability', text: 'Solutions designed to grow along with your business.' },
      ],
    },
    faq: {
      title: { pre: 'Frequently Asked ', hl: 'Questions', post: '' },
      text: 'Find answers to common questions about our services and how we work.',
      items: [
        {
          question: 'How long does a website project take?',
          answer: 'It depends on the complexity of the project. A standard website usually takes 2-4 weeks. More complex applications can take 1-12 months. We give you a clear time estimate at the start of the project.',
        },
        {
          question: 'Do you offer maintenance after the project is done?',
          answer: 'Yes, we provide ongoing maintenance and technical support. We offer monthly maintenance packages covering security updates, bug fixes, and technical support via WhatsApp and email.',
        },
        {
          question: 'What technologies do you use?',
          answer: 'We use current technologies such as Vue.js and Flutter for the frontend, and .NET, Laravel, and Nest.js for the backend. For databases, we use MySQL, PostgreSQL, and MS SQL Server, plus MongoDB and ClickHouse for analytics. For infrastructure, we work with AWS, Google Cloud, BiznetGIO, and other trusted cloud providers.',
        },
        {
          question: 'How do we start working together?',
          answer: 'It starts with a free consultation to understand your needs. We then prepare a full proposal covering the scope of work, timeline, and cost. Once it is approved, we go straight into development.',
        },
        {
          question: 'Can I request additional custom features?',
          answer: "Of course! We are always open to adapting our solutions to your business's unique needs. Our team will discuss the features you want and estimate the extra cost and time required.",
        },
      ],
    },
    cta: {
      badge: 'Get Started',
      title: { pre: "Let's Bring Your Digital Vision to Life With ", hl: 'Mira Solutions', post: '' },
      text: 'Contact us today to discuss how we can help your business grow and succeed in an ever-changing digital world.',
      contact: 'Contact Us Now',
    },
  },
})
